/* BASE CUSTOMIZER CODE 
    This cannot be used as an HTML component. Its only purpose is to serve as base code for extending customizers.
  */
class CustomizerBase extends HTMLElement {
  constructor() {
    super();
    window.customizer = window.customizer || {};
    window.customizer.el = this;
    this.pixi = window.PIXI;
    this.images = this.dataset.images.split(',');
    this.type = this.dataset.type;
    this.form = this.querySelector('.form');
    this.cartHolder = document.createElement('div');
    this.cartHolder.classList.add('js-cart-holder');
    this.form.appendChild(this.cartHolder);
    this.handle = this.dataset.handle;
    this.data = this.dataLoad();
  }

  get id() {
    return this.data?.id || this.dataset.id;
  }
  set id(id) {
    this.data.id = id;
    this.dataSave();
  }

  get localStore() {
    return JSON.parse(localStorage.getItem('customizer_store')) || [];
  }
  set localStore(store) {
    localStorage.setItem('customizer_store', JSON.stringify(store));
  }

  get variantColor() {
    return this.data?.variantColor || this.dataset.color;
  }

  set variantColor(color) {
    this.data.variantColor = color;
    this.dataSave();
  }

  get onEdit() {
    return this.id != this.dataset.handle;
  }

  async connectedCallback() {
    this.addEvents();
    await this.init();
  }

  dataLoad() {
    const savedData = this.localStore.find((record) => record.id === this.id);
    if (savedData) return savedData;
    // Default data:
    return {
      id: this.handle,
      handle: this.handle,
      type: this.type,
      variantColor: this.variantColor,
    };
  }

  dataSave(forceSave = false) {
    if (this.id == this.handle) return;
    if (!this.onEdit || forceSave) {
      const store = this.localStore;
      const existing = store.find((record) => record.id === this.data.id);
      if (existing) {
        Object.assign(existing, this.data)
      }
      else {
        store.push(this.data);
      }
      this.localStore = store;
    }
  }

  toggleSubmitState({ disabled }) {
    const submitButton = this.form.querySelector('button[type="submit"]');
    submitButton.disabled = disabled;
    if (disabled) {
      submitButton.classList.add('disabled');
    } else {
      submitButton.classList.remove('disabled');
    }
  }

  initControls() {
    this.updateColorSwatch(true);
  }

  updateColorSwatch(fireClick) {
    this.querySelectorAll('[data-name-handle="material"]').forEach((option) => {
      option.checked = false;
      if (option.dataset.valueHandle == this.variantColor) {
        if (fireClick) option.click();
        option.checked = true;
      }
    });
  }

  addEvents() {
    this.onVariantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange.bind(this));

    this.form.querySelector('button[type="submit"]').addEventListener('click', async (e) => {
      e.preventDefault();
      this.form.querySelector('button[type="submit"]').disabled = true;
      await this.cartPrepare();
      this.form.dispatchEvent(new CustomEvent('submit'));
      this.updateAtc();
      this.form.querySelector('button[type="submit"]').disabled = false;
    });

    // Listen for modal closed event to reset the customizer
    document.body.addEventListener('modalClosed', () => {
      this.reset();
    });
  }

  updateAtc() {
    this.form.querySelector('button[type="submit"] span').textContent = 'עדכן';
  }

  async init() {
    if (this.pixi) {
      await this.initCanvas();
      await this.renderMainImage();
      await new Promise((resolve) => requestAnimationFrame(resolve));
      this.style.opacity = 1;
      this.onEdit && this.updateAtc();
    } else {
      console.error('Pixi loading error');
    }
  }

  /**
   * Resets the customizer to its initial state
   */
  async reset() {
    if (this.onEdit) {
      const url = window.location.pathname;
      fetch(url)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const freshModal = doc.querySelector('#customizer-modal .customizer-container');
          const currentModal = document.querySelector('#customizer-modal .customizer-container');
          if (freshModal && currentModal) {
            currentModal.innerHTML = freshModal.innerHTML;
          }
        });
    }
  }

  async initCanvas() {
    this.app = new this.pixi.Application();
    await this.app.init({
      width: 600,
      height: 800,
      backgroundAlpha: 0,
      backgroundColor: 0xffffff,
    });

    this.querySelector('.customizer-canvas').appendChild(this.app.canvas);

    this.images.map((image, i) => {
      if (image) {
        const [alias, src] = image.split('|');
        delete this.images[i];
        this.images[alias] = src;
      }
    });
  }

  // async saveToBlob() {
  //   const extractedCanvas = await this.app.renderer.extract.canvas(this.app.stage);

  //   extractedCanvas.toBlob((blob) => {
  //     if (blob) {
  //       const link = document.createElement('a');
  //       link.href = URL.createObjectURL(blob);
  //       link.download = 'pixijs-image.png';
  //       link.click();
  //       URL.revokeObjectURL(link.href);
  //     } else {
  //       console.error('Failed to generate Blob from canvas.');
  //     }
  //   }, 'image/png'); // Specify MIME type
  // }

  async saveImage() {
    try {
      this.isSavingImage = true;
      this.refreshCanvas();
      this.render();
      await new Promise((resolve) => requestAnimationFrame(resolve));
      const extractedCanvas = await this.app.renderer.extract.canvas(this.app.stage);
      const base64String = extractedCanvas.toDataURL('image/png');
      this.isSavingImage = false;
      this.refreshCanvas();
      this.render();

      return base64String;
    } catch (error) {
      console.error('Error generating Base64 string:', error);
    }
  }

  async refreshCanvas() {
    this.clearCanvasItems();
    await this.renderMainImage();
  }
  clearCanvasItems() {
    while (this.app.stage.children.length > 0) {
      const child = this.app.stage.children[0];
      this.app.stage.removeChild(child); // Remove the child from the stage
      child.destroy(); // Free up memory and resources
    }
  }
  async renderMainImage() {
    // Main image load
    const imageAlias = `image_${this.variantColor}`.replaceAll('-', '_');

    const texturePromise = this.pixi.Assets.load(this.images[imageAlias]);
    await texturePromise.then((texture) => {
      const bg = this.pixi.Sprite.from(texture);
      const ratio = texture.orig.height / texture.orig.width;
      bg.x = 0;
      bg.y = 0;
      bg.width = this.app.screen.width;
      bg.height = this.app.screen.width * ratio;
      this.app.stage.addChild(bg);
    });
  }

  handleVariantChange({ data: { event, target, variant } }) {
    this.variantColor = handleize(variant.option1);
    this.dataset.color = this.variantColor;
    this.updateColorSwatch();
    this.variantChangeCallBack();
  }
  variantChangeCallBack() {
    this.onEdit && this.updateAtc();
  }
  cartAppend(inputName, inputValue) {
    let form_input = document.createElement('input');
    form_input.setAttribute('type', 'hidden');
    form_input.setAttribute('name', inputName);
    form_input.value = inputValue;
    this.cartHolder.appendChild(form_input);
  }
  async cartPrepare() {
    this.cartHolder.innerHTML = '';
    await this.clearPreviousCustomization(this.id);
    const imageBase64 = await this.saveImage();
    this.id = this.uid();
    this.data.image = imageBase64;
    this.dataSave(true);
    this.cartAppend(`properties[_customization_id]`, this.id);
  }
  async clearPreviousCustomization(id) {
    this.localStore = this.localStore.filter((item) => item.id !== id);
    await fetch('/cart.js')
      .then((response) => response.json())
      .then(async (cart) => {
        const updates = {};
        cart.items.forEach((item) => {
          if (item.properties._customization_id === id) {
            updates[item.key] = 0;
          }
        });
        await fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body: JSON.stringify({ updates }) });
      });
  }
  uid() {
    return Date.now().toString(36) + Math.random().toString(36).substring(2);
  }
}
